/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Delete_SuccessInputs */



/**
* | output |
* | --- |
* | "MCP server deleted." |
*
* @param {Mcp_Servers_Delete_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_delete_success = /** @type {((inputs?: Mcp_Servers_Delete_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Delete_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("MCP-Server gelöscht.")
	return /** @type {LocalizedString} */ ("MCP server deleted.")
});